import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReapplyResponse } from 'api/AuthApi';
import { reapply } from 'thunks';

export enum ReapplyEditField {
  Email = 'email',
  Address = 'address',
  Employment = 'employment',
  CredentialDate = 'credentialDate',
  Income = 'income',
  AdditionalIncome = 'additionalIncome',
}

export interface ReapplyDataState {
  data?: ReapplyResponse;
  updatedFields: Partial<ReapplyResponse>;
  currentEditField?: ReapplyEditField;
  returnToConfirmAfterEdit: boolean;
  isReapplying: boolean;
}

const initialState: ReapplyDataState = {
  updatedFields: {},
  returnToConfirmAfterEdit: false,
  isReapplying: false,
};

const reapplyData = createSlice({
  name: 'reapplyData',
  initialState,
  reducers: {
    startReapplyEdit: (state, { payload }: PayloadAction<ReapplyEditField>) => {
      state.currentEditField = payload;
      state.returnToConfirmAfterEdit = true;
    },
    clearReapplyEdit: (state) => {
      state.currentEditField = undefined;
      state.returnToConfirmAfterEdit = false;
    },
    patchReapplyData: (state, { payload }: PayloadAction<Partial<ReapplyResponse>>) => {
      state.updatedFields = { ...state.updatedFields, ...payload };
    },
    setIsReapplying: (state, { payload }: PayloadAction<boolean>) => {
      state.isReapplying = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reapply.fulfilled, (state, { payload }: PayloadAction<ReapplyResponse>) => {
      state.data = payload;
      state.updatedFields = {};
      state.isReapplying = false;
      state.returnToConfirmAfterEdit = false;
      state.currentEditField = undefined;
    });
  },
});

export const { startReapplyEdit, clearReapplyEdit, patchReapplyData, setIsReapplying } = reapplyData.actions;

export default reapplyData.reducer;
